/**
 * Pure reducer for the TON preview screen (SNAKE-21).
 *
 * The screen has four UI states; the reducer is exported separately so it can
 * be exercised without a DOM/jsdom environment.
 */

export type TonPreviewStateKind =
  | 'loading'
  | 'subscribed'
  | 'not_subscribed'
  | 'error'

export interface TonPreviewState {
  kind: TonPreviewStateKind
  subscribedAt: string | null
}

export const initialTonPreviewState: TonPreviewState = {
  kind: 'loading',
  subscribedAt: null,
}

export type TonPreviewAction =
  | { type: 'load' }
  | { type: 'load_ok'; wantsRealStakes: boolean; subscribedAt: string | null }
  | { type: 'load_err' }
  | { type: 'subscribe_ok'; subscribedAt: string }
  | { type: 'unsubscribe_ok' }
  | { type: 'action_err' }

export function reduceTonPreview(
  state: TonPreviewState,
  action: TonPreviewAction
): TonPreviewState {
  switch (action.type) {
    case 'load':
      return { kind: 'loading', subscribedAt: null }
    case 'load_ok':
      return action.wantsRealStakes
        ? { kind: 'subscribed', subscribedAt: action.subscribedAt }
        : { kind: 'not_subscribed', subscribedAt: null }
    case 'load_err':
      return { kind: 'error', subscribedAt: state.subscribedAt }
    case 'subscribe_ok':
      return { kind: 'subscribed', subscribedAt: action.subscribedAt }
    case 'unsubscribe_ok':
      return { kind: 'not_subscribed', subscribedAt: null }
    case 'action_err':
      return { kind: 'error', subscribedAt: state.subscribedAt }
    default:
      return state
  }
}
